__turbopack_context__.v({
  "card": "vZgbpq_card",
  "card__message": "vZgbpq_card__message",
  "card__message-title": "vZgbpq_card__message-title",
});
